module.exports = require('./lib/business-hours');